/**
 * Zentrale Icon-Schicht auf Basis von Phosphor Icons.
 * Feine, edle Strichführung statt des generischen Standard-Sets.
 */
import {
  ArrowRight as PhArrowRight,
  ArrowLeft as PhArrowLeft,
  Buildings,
  CalendarBlank,
  Camera as PhCamera,
  Check as PhCheck,
  CheckCircle as PhCheckCircle,
  CaretDown,
  CaretUp,
  Clock as PhClock,
  CreditCard as PhCreditCard,
  Database as PhDatabase,
  DownloadSimple,
  PencilSimple,
  ArrowSquareOut,
  Eye as PhEye,
  FileText as PhFileText,
  FunnelSimple,
  Gift as PhGift,
  Globe as PhGlobe,
  Heart as PhHeart,
  House,
  Image as PhImage,
  InstagramLogo,
  SquaresFour,
  Lightbulb as PhLightbulb,
  CircleNotch,
  Lock as PhLock,
  SignIn,
  SignOut,
  Envelope,
  MapPin as PhMapPin,
  List as PhList,
  ChatCircleText,
  Phone as PhPhone,
  Plus as PhPlus,
  ArrowsClockwise,
  FloppyDisk,
  MagnifyingGlass,
  PaperPlaneTilt,
  Gear,
  ShieldCheck,
  Sparkle,
  Star as PhStar,
  Storefront,
  Flask,
  ThumbsUp as PhThumbsUp,
  Trash,
  TrendUp,
  UploadSimple,
  User as PhUser,
  UserPlus as PhUserPlus,
  Users as PhUsers,
  X as PhX,
  XCircle as PhXCircle,
  Snowflake as PhSnowflake,
  Printer as PhPrinter,
} from "@phosphor-icons/react";

export const ArrowRight = PhArrowRight;
export const ArrowLeft = PhArrowLeft;
export const Building = Buildings;
export const Calendar = CalendarBlank;
export const CalendarIcon = CalendarBlank;
export const Camera = PhCamera;
export const Check = PhCheck;
export const CheckCircle = PhCheckCircle;
export const ChevronDown = CaretDown;
export const ChevronUp = CaretUp;
export const Clock = PhClock;
export const CreditCard = PhCreditCard;
export const Database = PhDatabase;
export const Download = DownloadSimple;
export const Edit = PencilSimple;
export const Edit2 = PencilSimple;
export const ExternalLink = ArrowSquareOut;
export const Eye = PhEye;
export const FileText = PhFileText;
export const Filter = FunnelSimple;
export const Gift = PhGift;
export const Globe = PhGlobe;
export const Heart = PhHeart;
export const Home = House;
export const ImageIcon = PhImage;
export const Instagram = InstagramLogo;
export const LayoutDashboard = SquaresFour;
export const Lightbulb = PhLightbulb;
export const Loader2 = CircleNotch;
export const Lock = PhLock;
export const LogIn = SignIn;
export const LogOut = SignOut;
export const Mail = Envelope;
export const MapPin = PhMapPin;
export const Menu = PhList;
export const MessageSquare = ChatCircleText;
export const Phone = PhPhone;
export const Plus = PhPlus;
export const RefreshCw = ArrowsClockwise;
export const Save = FloppyDisk;
export const Search = MagnifyingGlass;
export const Send = PaperPlaneTilt;
export const Settings = Gear;
export const Shield = ShieldCheck;
export const Sparkles = Sparkle;
export const Star = PhStar;
export const Store = Storefront;
export const TestTube = Flask;
export const ThumbsUp = PhThumbsUp;
export const Trash2 = Trash;
export const TrendingUp = TrendUp;
export const Upload = UploadSimple;
export const User = PhUser;
export const UserPlus = PhUserPlus;
export const Users = PhUsers;
export const X = PhX;
export const XCircle = PhXCircle;
export const Snowflake = PhSnowflake;
export const Printer = PhPrinter;
